import Vue from "vue";

/**
 * Auto-registra todos os componentes em /components (recursivamente).
 * Subpastas como /components/design/* ficam disponíveis globalmente.
 */
const files = require.context('../components', true, /\.vue$/)

files.keys().forEach(key => {
    const name = key.split('/').pop().split('.')[0]
    Vue.component(name, files(key).default)
})
